<script setup lang="ts">
import { useAuthSDK } from '~/features/auth-sdk';
import { MMText, MMLink, MMIcon } from '@mm-frontend/mm-web-ui-kit';
import { ERouteName } from '~/app/router/routeName.enum';
import ButtonTertiaryGhost from '~/features/ui-kit/buttons/ui/ButtonTertiaryGhost.vue';
import { useSignIn } from '~/features/sign-in/business/useSignIn';
import { useUserStore } from '~/features/store/user';
import { formatPhone } from '~/shared/helpers/formatPhone';

const { isAuthorized } = useAuthSDK();
const { openSignInPopup } = useSignIn();
const { profile } = useUserStore();
</script>

<template>
  <div class="user-modal__auth">
    <MMLink
      v-if="isAuthorized"
      :to="{ name: ERouteName.USER_SETTINGS }"
      class="user-modal__profile"
    >
      <div class="user-modal__profile-info">
        <MMText font="Body L/Regular">{{ profile?.name }}</MMText>
        <MMText font="Body M/Regular" color="tertiary">{{ formatPhone(profile?.phone) }}</MMText>
      </div>
      <MMIcon name="edit-outlined" :height="24" :width="24" />
    </MMLink>

    <ButtonTertiaryGhost v-else class="user-modal__auth-button" size="m40" @click="openSignInPopup">
      Войти
    </ButtonTertiaryGhost>
  </div>
</template>

<style lang="stylus" scoped>
.user-modal__auth
  padding 10px 16px
  display flex
  flex-direction column
  gap 4px

  & .user-modal__profile
    width 100%
    display flex
    justify-content space-between
</style>
